import React from 'react';
import {
  FooterContainer,
  FooterContent,
  MainSection,
  LeftSection,
  Logo,
  Tagline,
  NavigationSection,
  NavigationColumn,
  NavLink,
  RightSection,
  ContactTitle,
  ContactDetails,
  ContactItem,
  BottomSection,
  Copyright,
  LegalLinks,
} from './Footer.styled';
import logo from '../../../assets/logo-compressed.svg';

export const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <MainSection>
          <LeftSection>
            <Logo>
              <img src={logo} alt="YourEDU" />
            </Logo>
            <Tagline>Your All-in-One Homeschooling Management Platform</Tagline>
          </LeftSection>
          
          <NavigationSection>
            <NavigationColumn>
              <NavLink href="https://youredu.com" target="_blank" rel="noopener noreferrer">
                YourEDU Landing Page
              </NavLink>
              <NavLink href="https://app.youredu.com" target="_blank" rel="noopener noreferrer">
                YourEDU App
              </NavLink>
            </NavigationColumn>
          </NavigationSection>
          
          <RightSection>
            <ContactTitle>Contact Us</ContactTitle>
            <ContactDetails>
              <ContactItem>
                <a href="tel:+16469466198">+1 (646)-946-6198</a>
              </ContactItem>
              <ContactItem>
                <a href="mailto:support@YourEDU.com">support@YourEDU.com</a>
              </ContactItem>
            </ContactDetails>
          </RightSection>
        </MainSection>
        
        <BottomSection>
          <Copyright>© 2025 YourEDU. All rights reserved.</Copyright>
          <LegalLinks>
            <Copyright>Made with ❤️ in Stanford, California.</Copyright>
          </LegalLinks>
        </BottomSection>
      </FooterContent>
    </FooterContainer>
  );
}; 